import { fromLonLat } from 'ol/proj';
import { cageStyle } from './styles';
import Feature from 'ol/Feature';
import { Circle as CircleGeometry } from 'ol/geom';
import { CageDrawingPropertyDto } from 'models/mooring';
import VectorSource from 'ol/source/Vector';
import { Coordinate } from 'ol/coordinate';
import { circumferenceToRadius } from '../helpers';
import { mapFeature, MapRenderOptions } from '../renderOptions';
import { BuoyMappedForDrawing } from '../buoy';
import { calculateCagePositions } from './transform';

type RenderCagesProps = {
  grid: BuoyMappedForDrawing[][];
  vectorSource: VectorSource;
  cages: CageDrawingPropertyDto[];
};
export const renderCages = ({ cages, vectorSource, grid }: RenderCagesProps, renderOptions?: MapRenderOptions) => {
  const cagesForDrawing = calculateCagePositions(grid, cages);

  if (!cagesForDrawing || cagesForDrawing.length === 0) return;

  for (const cage of cagesForDrawing) {
    renderCage({
      center: cage?.Center ?? [0, 0],
      id: cage.Id,
      vectorSource,
      circumference: cage.Diameter ?? 10,
      label: cage.AnalysisNo ?? '',
    });
  }
};

type RenderCageProps = {
  id: string | number;
  label: string | number;
  circumference: number;
  vectorSource: VectorSource;
  center: Coordinate;
};
export const renderCage = ({ id, label, vectorSource, center, circumference }: RenderCageProps) => {
  const circleFeature = new Feature({
    geometry: new CircleGeometry(fromLonLat(center), circumferenceToRadius(circumference) * 2),
    type: mapFeature.cage,
    id: id,
  });
  circleFeature.setStyle(cageStyle(label));
  vectorSource.addFeature(circleFeature);
  return circleFeature;
};
